var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center align-items-center w-100 h-100"},[_c('div',{staticClass:"font-size-h2 text-header-color text-center"},[_vm._v("SITE DOES NOT EXIST.")])])
}]

export { render, staticRenderFns }